export const getReferralNew = `query GetReferral($id: ID!) {
  getReferral(id: $id) {
    id
    adminNote
    atsId
    diversityHire
    startDate
    bonuses {
      id
      amountDue
      bonusStatus
      companyId
      contactId
      earnedDate
      hireDate
      jobId
      payment
      recipientType
      referralId
      startDate
      userId
      notes
    }
    companyId
    company {
      id
      name
      defaultBonusAmount
      contactIncentiveBonus
      websiteUrl
      preStartEnabled
      preStartUserGroupId
      dateCreated
    }
    contactId
    contact {
      id
      atsId
      firstName
      lastName
      emailAddress
      socialMediaAccounts
      userId
      phoneNumber
      onDeckStatus
      onDeckNote
      onDeckDate
      contactResume {
        bucket
        region
        key
      }
      dateCreated
    }
    userId
    user {
      id
      cognitoId
      companyId
      emailAddress
      firstName
      lastName
      title
      departmentId
      lastLogin
      lastNotificationCheck
      incentiveEligible
      userGroupId
    }
    userGroupId
    userGroup {
      id
      name
    }
    jobId
    job {
      id
      companyId
      departmentId
      department {
        id
        name
      }
      title
      description
      publicLink
      salary
      location
      hiringManagerId
      createdById
      referralBonus
      tieredBonus {
        id
        name
        tiers
      }
      shares
      views
      dateCreated
   
    }
    status
    bonusStatus
    message
    note
    origin
    ownershipAtsId
    ownershipEndDate
    referralDate
    referralType
    hireDate
    questionsData
    candidateQuestionsData
    interestedQuestionsData
    customStatus
    contactResume {
      bucket
      region
      key
    }
  }
}
`;